// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__17dv8","file":"styles_file__JbtL3"};